// extracted by mini-css-extract-plugin
module.exports = {"headerDiv":"Header_headerDiv__V-J4N","headerH1":"Header_headerH1__3p_XS","goToBack":"Header_goToBack__2MdZ_","headerContainerHide":"Header_headerContainerHide__2BlTH"};